module.exports = __webpack_public_path__ + "static/img/coursebg.47e91f46.png";